import { BookingSession, GuestInfo, TentativeBookingResult } from "../../Models";

export class GuestInfoForm {
    constructor(
        public readonly guestInfo: GuestInfo,
        public readonly totalAdults:number, 
        public readonly totalChildren:number, 
        public readonly specialRequest:string
    ){}
}

export class GuestFormContext{
    constructor(
        public readonly bookingSession: BookingSession,
        public readonly guestInfoForm: GuestInfoForm|null = null,
        public readonly tentativeBookingResult: TentativeBookingResult|null = null
    ){}

    withGuestInfoForm(guestInfoForm: GuestInfoForm){
        return new GuestFormContext(this.bookingSession, guestInfoForm, this.tentativeBookingResult);
    }

    withTentativeBookingResult(tentativeBookingResult: TentativeBookingResult){
        return new GuestFormContext(this.bookingSession, this.guestInfoForm, tentativeBookingResult);
    }
}

export type GuestFormSubManifest = {
    context: GuestFormContext,
    substates: [
        'showing_guest_form',
        'creating_tentative_booking',
        'confirming_exit_guest_info'
    ],
    events: {
        'guest_info_submitted': {guestInfoForm: GuestInfoForm},
        'tentative_booking_created' : {
            tentativeBookingResult:TentativeBookingResult
        },
        'tentative_booking_failed' : {},
        'back': {},
        'exit_confirmed': {},
        'exit_cancelled': {}
    }
}